import type { FC } from 'react';
import { Button, ButtonGroup, Card, CardBanner } from '@george-labs.com/design-system';

import { isVanillaApp, switchToDefault, switchToVanilla } from './layoutSwitchService';

export const LayoutSwitch: FC = () => {
    const isVanillaAppRunning = isVanillaApp();

    return (
        <Card nested={false} className="rounded-0">
            <CardBanner>Layout switch</CardBanner>
            <Card>
                <ButtonGroup segmented>
                    <Button onClick={switchToDefault} aria-pressed={!isVanillaAppRunning}>
                        Web
                    </Button>
                    <Button onClick={switchToVanilla} aria-pressed={isVanillaAppRunning}>
                        Mobile
                    </Button>
                </ButtonGroup>
            </Card>
        </Card>
    );
};
